import React from 'react';
import { ImageBackground } from 'react-native';
import { Device } from 'DeviceUtils';
import FadeView from 'LocalGluons/components/FadeView';

const SplashScreen = () => {
    let source = '';
    if (Device.isTablet) {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line global-require
        source = require('../../../../platformAssets/runtime/images/tablet-splash.png');
    } else if (Device.isPhone) {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line global-require
        source = require('../../../../platformAssets/runtime/images/mobile-splash.png');
    }

    return (
        <FadeView>
            <ImageBackground source={source} style={{ width: '100%', height: '100%' }} />
        </FadeView>
    );
};

export default SplashScreen;
